// removed by extract-text-webpack-plugin
module.exports = {"slant":"styles__slant__2ZTuS","main":"styles__main__vgBvK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Startup/styles.scss
// module id = 426
// module chunks = 0